import moment from "moment";

export const formatDate = (date) => {
  const formattedDate = moment(date).format("YYYY-MM-DD");
  return formattedDate;
};